import resume from "../../resume/Vishal_Resume.pdf";

export const WorkTimeLine = () => {
  const workData = [
    {
      company: "Evobi Automations Pvt Ltd",
      link: "",
      linkText: "(Bibox Labs)",
      location: "India",
      description:
        "An edutech company dedicated to creating products and support software that make coding fun and engaging for kids.",
      roles: [
        {
          title: "Full Stack Developer",
          period: "Jun 2022 - Jul 2024",
          description:
            "Worked on web-based and AI-enabled applications for education and embedded systems, developing backend APIs, authentication and authorization systems, AI-powered features, firmware flashing tools, and CI/CD workflows using technologies including TypeScript, NestJS, React, MongoDB, TensorFlow.js, and AWS..",
          points: {
            "Backend Infrastructure Architecture":
              "Architected and implemented REST APIs for Port11 (LMS) using NestJS, TypeScript, and MongoDB, and created Swagger for standardized API discovery and integration.",
            "Business Logic & Security Engineering":
              "Engineered scoring, results management, and authorization workflows using MongoDB and CASL.js, implementing role-based access control across core LMS functionality.",
            "Database Workflow Optimization":
              "Designed custom Mongoose middleware and aggregation pipelines to streamline complex document operations and data retrieval workflows.",
            "AppMode with AI Capabilities":
              "Engineered an AI-powered feature used across 15+ schools, enabling real-time speech, facial, and object recognition using React Speech Recognition and Google Teachable Machine/TensorFlow.js models, implemented on-device face embeddings with IndexedDB for fast re-identification across up to 5 saved profiles.",
            "OAuth 2.0 Authentication Flow":
              "Implemented a robust security system using JWT Access and Refresh tokens to ensure secure, persistent user sessions and minimize unauthorized access risks.",
            "ESP Flasher Tool":
              "Designed a standalone React application for seamless, user-friendly firmware updates on EspressIf microcontrollers.",
            "Automated CI/CD & Firmware Deployment":
              "Engineered a Bitbucket pipeline to automate firmware delivery from embedded teams to web servers, streamlining cross-functional hand-offs and ensuring real-time availability for updates.",
            "Interactive Game Engine":
              "Built a specialized engine for children's gaming experiences using BabylonJS.",
            "Agile Development & Project Management":
              "Followed an Agile/Kanban workflow, translating requirements into user stories, managing tasks through a Kanban board, and tracking tickets from creation through completion across development cycles.",
          },
        },
      ],
    },
    {
      company: "All Blue Solutions",
      link: "https://subscribeit.com/",
      linkText: "(Subscribe IT)",
      location: "Remote",
      description:
        "SubscribeIT specializes in enterprise software solutions, offering expertise in software asset management, security, infrastructure, and cloud services for major platforms like Oracle, Microsoft, and IBM.",
      roles: [
        {
          title: "Software Developer",
          period: "Jul 2021 – Feb 2022",
          description: null,
          points: {
            "Cross-Platform App Development":
              "Engineered an integrated chatbot application using Angular and extended its functionality to a mobile environment via the Ionic framework.",
            "Post-Production Software Support":
              "Managed full-lifecycle enhancements and critical bug resolution across the stack, leveraging Angular for the frontend and Spring Boot for the backend to deliver stable, high-quality application features.",
          },
        },
      ],
    },
  ];

  return (
    <div className="flex flex-col w-full h-full mt-10">
      <div className="flex items-center justify-between">
        <div className="bg-gradient-to-tr from-peach to-peachLite bg-clip-text text-transparent text-4xl font-medium">
          Work
        </div>
        <button className="bg-white text-sm sm:text-base md:text-base font-medium cursor-pointer px-4 py-2 sm:px-5 sm:py-2.5 md:px-5 md:py-2.5 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-blue">
          <a
            href={resume}
            download={"Vishal_Resume.pdf"}
            className="bg-gradient-to-tr from-peach to-peachLite bg-clip-text text-transparent"
          >
            Resume
          </a>
        </button>
      </div>

      <div className="flex flex-col leading-loose font-normal text-blue text-base sm:text-lg md:text-xl max-w-full md:leading-loose mt-6">
        {/* Timeline container */}
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gradient-to-tr from-peach to-peachLite"></div>

          {workData.map((job, jobIndex) => (
            <div
              key={jobIndex}
              className={`relative pl-8 sm:pl-12 ${
                jobIndex > 0 ? "mt-8 sm:mt-10 md:mt-12" : ""
              }`}
            >
              {/* Timeline dot */}
              <div className="absolute left-[0.55rem] top-2 sm:top-[0.70rem] w-4 h-4 bg-gradient-to-tr from-peach to-peachLite rounded-full border-2 border-blue shadow-md"></div>

              <h3 className="font-semibold mb-3 sm:mb-4">
                {job.company}{" "}
                <span className="text-base font-normal"> | {job.location}</span>
              </h3>

              <p className="mb-6 sm:mb-8">{job.description}</p>

              <div className="pl-3 sm:pl-5 space-y-6 sm:space-y-8">
                {job.roles.map((role, roleIndex) => (
                  <div key={roleIndex} className="relative">
                    {/* Position dot */}
                    <div className="absolute left-[-2.1rem] sm:left-[-3.55rem] top-2 sm:top-[0.70rem] w-3 h-3 bg-gradient-to-tr from-peach to-peachLite rounded-full border-2 border-blue shadow-sm"></div>

                    <p className="font-medium mb-3">
                      {role.title}{" "}
                      <span className="text-base font-normal">
                        | {role.period}
                      </span>
                    </p>

                    {role.description && (
                      <p className="mb-4">{role.description}</p>
                    )}
                    <ul className="list-disc pl-6 space-y-2 sm:space-y-3">
                      {Object.entries(role.points).map(([jist, point]) => (
                        <li key={jist} className="leading-relaxed">
                          <b>{jist}</b> : {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
